<template>
  <div>
    <div class="vx-row">
      <vx-card title no-shadow card-border>
        <ValidationObserver ref="observer">
          <div class="vx-row">
            <div class="vx-col w-full">
              <ul class="heading-ul mb-5">
                <li>
                  <router-link to="/inventory/item-model" class="vx-row">
                    <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                    <h4>{{ $t("setup.label.EditItemModel") }}</h4>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Make')"
              >
                <vs-input
                  :label="$t('setup.label.Make')"
                  class="w-full mb-2 font-semibold"
                  v-model="itemModel.make"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Model')"
              >
                <vs-input
                  :label="$t('setup.label.Model')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="itemModel.model"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.ItemType")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="$t('setup.label.ItemType')"
                >
                  <v-select
                    label="item"
                    :options="itemTypes"
                    v-model="itemModel.itemType"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                    <template v-slot:option="option">{{
                      option.item
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="dropdown-with-label">
                <small class="date-label font-semibold starlabel"
                  >{{ $t("setup.label.NetworkElement")
                  }}<span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.NetworkElement')"
                >
                  <v-select
                    label="systemname"
                    v-model="itemModel.provisioningId"
                    :options="provisionDatas"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.systemname
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row center my-2">
            <div class="vx-col w-full">
              <vs-button
                color="warning"
                type="border"
                class="mb-2"
                @click="cancel"
                style="margin-right: 10px"
                >{{ $t("setup.label.Cancel") }}</vs-button
              >
              <vs-button class="mr-3 mb-2" @click="handleEditItemModel">{{
                $t("setup.label.Submit")
              }}</vs-button>
            </div>
          </div>
        </ValidationObserver>
      </vx-card>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const itemModelEmptyObj = {
  itemType: "",
  locale: "en",
  make: "",
  model: "",
  provisioningId: "",
  warningPopup: false,
  warningText: "",
  errorMessage: "",
};

export default {
  data() {
    return {
      itemModel: itemModelEmptyObj,
      itemTypes: ["SD", "HD", "PVR"],
      provsCodes: [],
      provsIds: [],
      errorMessage: "",
      provisioning: "",
      id: 0,
      warningPopup: false,
      warningText: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      itemModelData: (state) => state.itemModel.itemModelData,
      provisionDatas: (state) => state.itemModel.provisionDatas,
    }),
  },
  methods: {
    async getItemModel() {
      try {
        await this.$store.dispatch(
          "itemModel/fetchItemModelById",
          this.$route.params.id
        );
        this.itemModel = { ...this.itemModelData };
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async handleEditItemModel() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      delete this.itemModel.id;
      delete this.itemModel.provisioningName;
      try {
        await this.$store.dispatch("itemModel/editItemModelAction", {
          id: this.$route.params.id,
          data: this.itemModel,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Model Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/inventory/item-model`);
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getItemModelTemplate() {
      try {
        await this.$store.dispatch("itemModel/fetchItemModelTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    cancel() {
      this.$router.push(`/inventory/item-model`);
    },
  },
  // watch: {
  //   data(val) {
  //     this.provisionDatas = val.provisionDatas;
  //   },
  // },
  mounted() {
    this.getItemModelTemplate();
    this.getItemModel();
  },
};
</script>
